import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import arrIcon from "../../../images/svg/jobList/arr1.svg"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { deleteGunlukArac, getDevamliAraclar, handleFrameState, setAracBekleyenYukCheckedItem, setCleanGunlukAraclarFilterValues, setYukBekleyenAracCheckedItemList } from "../../../features/joblist/jobListSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { BsCheck } from "react-icons/bs"
import getEslestir from "../../../helper/jobList/getEslestir"
import { showModal } from "../../../features/modal/modalSlice"
import { MdOutlineMoreHoriz } from "react-icons/md";
import AracTypeFilter from "../../shared/gunlukAraclarFilter/AracTypeFilter"
import PlakaFilter from "../../shared/gunlukAraclarFilter/PlakaFilter"
import RateFilter from "../../shared/gunlukAraclarFilter/RateFilter"
import CityCanGoFilter from "../../shared/gunlukAraclarFilter/RegionCanGoFilter"
import { useSelector } from "react-redux"
import { getAracTypes } from "../../../features/adminSett/adminSettSlice"
import Iller from "../../../utils/iller"
import { useEffect } from "react"
import StarRatings from "react-star-ratings"
import getGivenDateAndTime from "../../../helper/getGivenDateAndTime"
import {AdminAracEkleOptions} from "../../../utils/adminAracEkleOptions"
import useWindowDimensions from "../../../hooks/useWindowSize"


const Container = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${({theme}) => theme.mainTextColor};


    .topp-container{
        width: 100%;
        margin-bottom: 5px;

        h2{
            text-align: center;
            font-size: var(--font-size-xl);
            font-weight: var(--font-weight-xl);
        }
    }

    .content-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        border: 3px solid ${({theme}) => theme.mainBorderColor};
        padding: 5px;
        border-radius: 10px;
        position: relative;


        .opitons{
            position: absolute;
            top: 5px;
            right: 10px;
            z-index: 20;
            font-size: 20px;
            cursor: pointer;
            .options-detail{
                position: absolute;
                right: 0px;
                top: 20px;
                width: 100px;
                height: 25px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                background-color: ${({theme}) => theme.secondaryBgColor};
                border-radius: 8px;
                padding: 5px;
            }
        }

        .arr-btn{
            position: absolute;
            top: 0;
            right: 0;
        }


        .content-top-container{
            width: 90%;
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 15px;

            .clean{
                border: 1px solid var(--color-main);
                border-radius: 10px;
                padding: 10px;
                color: var(--color-main);
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .main-content{
            width: 100%;
            display: flex;
            flex-direction: column;

            .content-list{
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }
    @media (max-width: 1500px){
        .content-top-container{
            width: 100% !important;
        }
    }
    @media (max-width: 1200px){
        .content-top-container{
            display: grid !important;
            grid-template-columns: repeat(3, 1fr);
        }
    }
`

const ContentItem = styled.div`
    width: 100%;
    padding:  10px;
    padding-bottom: 25px;
    border: 2px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 10px;
    position: relative;
    display: flex;
    justify-content: space-between;
    background-color: ${({theme, isChecked}) => isChecked ? "rgba(250, 136, 136, 0.1)" : theme.mainBgColor};

    .column-grp{
        display: flex;
        gap: 20px;


    .column-item{
        display: flex;
        flex-direction: column;
        gap: 5px;

        &:first-child{
            margin-right: 5px;
        }

        .item-title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .placeholder{
            visibility: hidden;
        }

        .underline{
            text-decoration: underline;
        }

        .checkbox{
            width: 20px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid ${({theme, isChecked}) => !isChecked ? theme.mainTextColor : "none"};
            background-color: ${({theme, isChecked}) => isChecked ? "var(--color-main)" : theme.secondaryBgColor};
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            .check-icon{
                font-size: 2.6rem;
                color: #fff;
            }
        }      

    
        .item-data{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            display: flex;
            align-items: center;
            gap: 5px;

            .title-id{
                text-decoration: underline;
                color: var(--color-main);
                font-weight: var(--font-weight-xl);

            }

            .passive-title-id{
                color: ${({theme}) => theme.secondaryTextColor};
                font-weight: var(--font-weight-xl);
                position: relative;
                
                .detail-box{
                    display: none;
  
                }

                &:hover{

                    .detail-box{
                        display: flex;
                        position: absolute;
                        top: -40px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: max-content;
                        padding: 8px 10px;
                        border-radius: 5px;
                        height: auto;
                        color: ${({theme}) => theme.mainTextColor};
                        font-size: 12px;
                        font-weight: 600;
                        background-color: ${({theme}) => theme.mainBgColor};
                        border: solid 1px var(--color-main);
                    }
                }

            }

            .item-data-id{
                display: flex;
                flex-wrap: wrap;
            }
        }
    }
    
    .seperator{
        height: auto;
        width: 2px;
        background-color: ${({theme}) => theme.mainTextColor};
    }

}

    .column-grp-content{
        flex: 1;
    }

    .column-grp-seperator{
        flex: 0.1;
    }

    .more-btn{
        font-size: 10px;
        font-weight: var(--font-weight-md);
        color: ${({theme, isOpened}) => isOpened ? "var(--color-main)" : theme.secondaryTextColor};
        position: absolute;
        bottom: 4px;
        right: 6px;
        cursor: pointer;
    }


   

`

const rateData = [
    {
        id:1,
        name: <StarRatings rating={1} starRatedColor="#E85446" starEmptyColor="#aaa3a3" starDimension="15px" starSpacing="2px"/>
    },
    {
        id:2,
        name:<StarRatings rating={2} starRatedColor="#E85446" starEmptyColor="#aaa3a3" starDimension="15px" starSpacing="2px"/>
    },
    {
        id:3,
        name:<StarRatings rating={3} starRatedColor="#E85446" starEmptyColor="#aaa3a3" starDimension="15px" starSpacing="2px"/>
    },
    {
        id:4,
        name:<StarRatings rating={4} starRatedColor="#E85446" starEmptyColor="#aaa3a3" starDimension="15px" starSpacing="2px"/>
    },
    {
        id:5,
        name:<StarRatings rating={5} starRatedColor="#E85446" starEmptyColor="#aaa3a3" starDimension="15px" starSpacing="2px"/>
    }
]

const WideAracSide = ({list, isLoading, checkedItemList, loadList}) => {
    const {gunlukAraclarFilterValues} = useSelector((state) => state.jobList)
    const {plakaSearch, aracTuruValue, cityCanGo, rateFilter} = gunlukAraclarFilterValues
    const [isOpenedItemId, setIsOpenedItemId] = useState(null)
    const dispatch = useDispatch()
    const {aracTypes} = useSelector((state)=> state.adminSett)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
    const dateFormatter = new Intl.DateTimeFormat('tr-TR', options);

    const {windowDimensions} = useWindowDimensions()

    const [moreActive, setMoreActive] = useState(null);

    useEffect(()=>{
        dispatch(getAracTypes())
      },[dispatch])

    const toggleMore = (item) => {
        if (moreActive === item) {
          setMoreActive(null);
        } else {
          setMoreActive(item);
        }
    };

    const handleEslesenItem = ({yukItem, aracItem}) => {

        dispatch(setYukBekleyenAracCheckedItemList(aracItem))
        dispatch(setAracBekleyenYukCheckedItem(yukItem))

        dispatch(handleFrameState("equal"))

    }

    const deleteDaily = (item) => {
        dispatch(deleteGunlukArac(item?.id))
    }

    const changeFrame = () => {
        if(windowDimensions?.width < 1500){
            dispatch(handleFrameState("yukSide"))
        }else{
            dispatch(handleFrameState("equal"))
        }
        
    }

  return (
    <Container>
        <div className="topp-container">
            <h2>Yük Bekleyen Araçlar</h2>
        </div>
        <div className="content-container">
            <button className="arr-btn" onClick={changeFrame}>
                <img src={arrIcon} alt="" />
            </button>
            <div className="content-top-container">
                <div className="row">
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"300px"} handleClick={() => dispatch(showModal("addJobListRegularVehicle"))}>Sıraya Araç Ekle</Btn>
                </div>
                <div className="row">
                    <AracTypeFilter labelText="Araç Tipi" name="aracTuruValue" keyData="aracTuruValue" data={aracTuruValue} options={AdminAracEkleOptions} width={"100%"} />
                </div>
                <div className="row">
                    <PlakaFilter labelText="Plaka" name="plakaSearch" keyData="plakaSearch" data={plakaSearch} width={"100%"} />
                </div>
                <div className="row">
                    <CityCanGoFilter labelText="Gidebileceği İller" name="cityCanGo" keyData="cityCanGo" data={cityCanGo} options={Iller} width={"100%"} />
                </div>
                <div className="row">
                    <RateFilter labelText="Puan" name="rateFilter" keyData="rateFilter" data={rateFilter} options={rateData} width={"100%"} />
                </div>
                <div onClick={ () => dispatch(setCleanGunlukAraclarFilterValues()) } className="clean">
                    Temizle
                </div>
            </div>
            <div className="main-content">
                {
                    isLoading ? <SmallSpinner size={"50px"} color={"#fff"} bgColor={"#E85446"}/>  
                :
                    <div className="content-list">
                    {
                        list.map(item => {
                            if(item.id === isOpenedItemId){
                                return (
                                     <ContentItem isOpened={item.id === isOpenedItemId} isChecked={checkedItemList.includes(item?.id)}>
                                        <div className="column-grp column-grp-content">
                                            <div className="column-item">
                                                <div className="checkbox" onClick={() => dispatch(setYukBekleyenAracCheckedItemList(item))}>
                                                    {
                                                        checkedItemList.includes(item?.id) &&
                                                        <BsCheck className="check-icon"/>
                                                    }
                                                </div>
                                            </div>
                                            <div className="column-item">
                                                <div className="item-title underline">Sürücü</div>
                                                <div className="item-title">Ad-Soyad</div>
                                                <div className="item-title">Puanı</div>
                                                <div className="item-title">Telefon</div>
                                                <div className="item-title">Kayıt Zamanı</div>
                                            </div>
                                            <div className="column-item">
                                                <div className="item-title placeholder">----</div>
                                                <div className="item-data">{item.devamliAraclar.firstLastName}</div>
                                                <div className="item-data">{item.communicationandCustomerServiceAvarage !== 0 ? <> <StarRatings rating={((item.communicationandCustomerServiceAvarage + item.deliveryTimeandReliabilityRateAvarage + item.equipmentConditionRateAvarage) / 3 )} starRatedColor="#E85446" starEmptyColor="#aaa3a3" starDimension="15px" starSpacing="0px"/> {((item.communicationandCustomerServiceAvarage + item.deliveryTimeandReliabilityRateAvarage + item.equipmentConditionRateAvarage) / 3 )?.toFixed(1)} </> : "Değerlendirme Yok" }</div>
                                                <div className="item-data">{item.devamliAraclar.phoneNumber}</div>
                                                <div className="item-data">{item.createdDate !== null && dateFormatter.format(new Date(item.createdDate))}</div>
                                            </div>
                                        </div>

                                        <div className="column-grp column-grp-seperator">
                                            <div className="seperator"/>
                                        </div>

                                        <div className="column-grp column-grp-content">
                                            <div className="column-item">
                                                <div className="item-title underline">Araç</div>
                                                <div className="item-title">Araç Türü</div>
                                                <div className="item-title">Plaka</div>
                                                <div className="item-title">Araç Nerede</div>
                                                <div className="item-title">Müsaitlik Durumu</div>
                                                <div className="item-title">Boşa Çıkma Zamanı</div>
                                            </div>

                                            <div className="column-item">
                                                <div className="item-title placeholder">---</div>
                                                <div className="item-data">{item?.truck.truckType} - {item?.truck?.trailerType}</div>
                                                <div className="item-data">{item?.truck?.plateNumber}</div>
                                                <div className="item-data">{item.vehicleCurrentLocation}</div>
                                                <div className="item-data">{item.vehicleStatus}</div>
                                                <div className="item-data">{item.timeToWaste !== null && dateFormatter.format(new Date(item.timeToWaste))}</div>
                                            </div>
                                        </div>

                                        <div className="column-grp column-grp-seperator">
                                            <div className="seperator"/>
                                        </div>

                                        <div className="column-grp column-grp-content">
                                            <div className="column-item">
                                                <div className="item-title underline">Güzergahı</div>
                                                <div className="item-title">Gidebileceği İller</div>
                                                <div className="item-title">Gidebileceği Bölgeler</div>
                                                <div className="item-title">Eşleşilen yük No'ları</div>
                                            </div>
                                            <div className="column-item">
                                                <div className="item-title placeholder">---</div>
                                                <div className="item-data">{item.gunlukAracListesiCityCanGos.map(item => `${item.cityCanGo} `)}</div>
                                                <div className="item-data">{item.gunlukAracListesiRegionCanGos.map(item => item.regionCanGo)}</div>
                                                <div className="item-data item-data-id">{getEslestir({loadList, aracItem:item}).map(innerItem => {
                                                    const idList = item.sendedLoadIdNotifications.map(idItem => idItem.loadId)
                                                    return(
                                                        <button key={innerItem.id} className={!idList.includes(innerItem.id) ? "title-id" : "passive-title-id"} onClick={()=> !idList.includes(innerItem.id) && handleEslesenItem({yukItem: innerItem, aracItem: item})}>{innerItem?.id}
                                                            {
                                                                item.sendedLoadIdNotifications.find(sendedItem => sendedItem.loadId === innerItem?.id) &&
                                                                <div className="detail-box">Teklifin Gönderilme Tarihi: {getGivenDateAndTime(item.sendedLoadIdNotifications.find(sendedItem => sendedItem.loadId === innerItem?.id).sendedDate).formattedDate} - {getGivenDateAndTime(item.sendedLoadIdNotifications.find(sendedItem => sendedItem.loadId === innerItem?.id).sendedDate).formattedTime}</div>
                                                            }
                                                        </button>
                                                    )})
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                     <button className="more-btn" onClick={() => setIsOpenedItemId(null)}>Detaylar kapat</button>
                                     <div className="opitons">
                                        <MdOutlineMoreHoriz onClick={()=>toggleMore(item)} />
                                        {moreActive?.id === item?.id &&
                                            <div className="options-detail">
                                                <span onClick={()=>deleteDaily(item)}>Sıradan Çıkar</span>
                                            </div>
                                        }
                                    </div>
                                 </ContentItem>
                                )
                            }
                            else{
                                return (
                                    <ContentItem isOpened={item.id === isOpenedItemId} isChecked={checkedItemList.includes(item?.id)}>
                                    <div className="column-grp column-grp-content">
                                        <div className="column-item">
                                            <div className="checkbox" onClick={() => dispatch(setYukBekleyenAracCheckedItemList(item))}>
                                                {
                                                    checkedItemList.includes(item?.id) &&
                                                    <BsCheck className="check-icon"/>
                                                }
                                            </div>
                                        </div>
                                        <div className="column-item">
                                            <div className="item-title underline">Sürücü</div>
                                            <div className="item-title">Ad-Soyad</div>
                                            <div className="item-title">Telefon</div>
                                        </div>
                                        <div className="column-item">
                                            <div className="item-title placeholder">---</div>
                                            <div className="item-data">{item.devamliAraclar.firstLastName}</div>
                                            <div className="item-data">{item.devamliAraclar.phoneNumber}</div>
                                        </div>
                                    </div>

                                    <div className="column-grp column-grp-seperator">
                                        <div className="seperator"/>
                                    </div>

                                    <div className="column-grp column-grp-content">
                                        <div className="column-item">
                                            <div className="item-title underline">Araç</div>
                                            <div className="item-title">Araç Türü</div>
                                            <div className="item-title">Plaka</div>
                                        </div>

                                        <div className="column-item">
                                            <div className="item-title placeholder">---</div>
                                            <div className="item-data">{item?.truck.truckType} - {item?.truck?.trailerType}</div>
                                            <div className="item-data">{item?.truck?.plateNumber}</div>
                                        </div>
                                    </div>

                                    <div className="column-grp column-grp-seperator">
                                        <div className="seperator"/>
                                    </div>

                                    <div className="column-grp column-grp-content">
                                        <div className="column-item">
                                            <div className="item-title underline">Güzergahı</div>
                                            <div className="item-title">Gidebileceği İller</div>
                                            <div className="item-title">Eşleşilen yük No'ları</div>
                                        </div>
                                        <div className="column-item">
                                            <div className="item-title placeholder">---</div>
                                            <div className="item-data">{item.gunlukAracListesiCityCanGos.map(item => `${item.cityCanGo} `)}</div>
                                            <div className="item-data item-data-id">{getEslestir({loadList, aracItem:item}).map(innerItem => {
                                                const idList = item.sendedLoadIdNotifications.map(idItem => idItem.loadId)
                                                return(
                                                    <button key={innerItem.id} className={!idList.includes(innerItem.id) ? "title-id" : "passive-title-id"} onClick={()=> !idList.includes(innerItem.id) && handleEslesenItem({yukItem: innerItem, aracItem: item})}>{innerItem?.id}
                                                        {
                                                            item.sendedLoadIdNotifications.find(sendedItem => sendedItem.loadId === innerItem?.id) &&
                                                            <div className="detail-box">Teklifin Gönderilme Tarihi: {getGivenDateAndTime(item.sendedLoadIdNotifications.find(sendedItem => sendedItem.loadId === innerItem?.id).sendedDate).formattedDate} - {getGivenDateAndTime(item.sendedLoadIdNotifications.find(sendedItem => sendedItem.loadId === innerItem?.id).sendedDate).formattedTime}</div>
                                                        }
                                                    </button>
                                                )})
                                                }
                                        </div>
                                        </div>
                                    </div>

                                 <button className="more-btn" onClick={() => setIsOpenedItemId(item.id)}>Detaylar için tıklayın</button>
                                 <div className="opitons">
                                        <MdOutlineMoreHoriz onClick={()=>toggleMore(item)} />
                                        {moreActive?.id === item?.id &&
                                            <div className="options-detail">
                                                <span onClick={()=>deleteDaily(item)}>Sıradan Çıkar</span>
                                            </div>
                                        }
                                    </div>
                             </ContentItem>
                                )

                            }
                        })
                    }
                </div>
                }

            </div>

        </div>
    </Container>
  )
}

export default WideAracSide